import {Button} from "@mantine/core";
import {useTranslation} from "react-i18next";
import type {LabelGroup, Status} from "../types";
import {SearchInput} from "./SearchInput";
import {StatusFilter} from "./StatusFilter";
import {ShowFilter} from "./ShowFilter";
import styles from "./checklist.module.css";

type ChecklistControlsProps = {
    allItemsExpanded: boolean;
    hasCollection: boolean;
    searchTerm: string;
    filterState: {
        statusFilterSelected: Record<string, (Status | string)[]>;
        showGroups: LabelGroup[];
        resetKey: string | number;
    };
    onExpandAll: () => void;
    onSearchChange: (term: string) => void;
    onStatusToggle: (id: string, status: Status | string) => void;
};

export const ChecklistControls = ({
    allItemsExpanded,
    hasCollection,
    searchTerm,
    filterState: {statusFilterSelected, showGroups, resetKey},
    onExpandAll,
    onSearchChange,
    onStatusToggle,
}: ChecklistControlsProps) => {
    const {t} = useTranslation();

    return (
        <div className={styles.checklistControls}>
            <div className={styles.checklistFilters}>
                {hasCollection && (
                    <StatusFilter
                        key={`status-${resetKey}`}
                        selected={statusFilterSelected["status"] ?? []}
                        onToggle={(status) =>
                            onStatusToggle("status", status)
                        }
                    />
                )}

                {showGroups.map((group) => (
                    <ShowFilter
                        key={`${group.id}-${resetKey}`}
                        group={group}
                        selected={
                            (statusFilterSelected[group.id] as string[]) ?? []
                        }
                        onToggle={(labelId) =>
                            onStatusToggle(group.id, labelId)
                        }
                    />
                ))}
            </div>

            <SearchInput
                key={`search-${resetKey}`}
                initialValue={searchTerm}
                onChange={onSearchChange}
            />

            <Button
                variant="subtle"
                size="compact-sm"
                color="gray"
                onClick={onExpandAll}
                className={styles.checklistExpandButton}
            >
                {allItemsExpanded ? t("Action.CloseAll") : t("Action.OpenAll")}
            </Button>
        </div>
    );
};
